class SignupCrumbDirective {
  constructor($log) {
    this.$log = $log
    this.restrict = 'E'
    this.templateUrl = 'signup-crumb.partial.html'
    this.scope = {
      label: '@',
      step: '@',
      separator: '@',
      controller: '='
    }
  }

  link(scope, element, attrs) {
    scope.currentStepAsInt = parseInt(scope.step)
    scope.stepIsAvailable = function() {
      var x =
        scope.controller.step > scope.currentStepAsInt || (
            scope.controller.step != scope.currentStepAsInt &&
            scope.controller.maxStepAvailable >= scope.currentStepAsInt
        )
      return x
    }
  }
}

SignupCrumbDirective.$inject = ['$log']

export default SignupCrumbDirective
